// Bongasoft user-service auth calls (login, refresh, logout, password flows).
import { post } from "./api_helper";
import * as url from "./url_helper";

// These auth forms own their own error UI. Pass skipAuthLogout so a 401/403
// (e.g. wrong credentials / wrong current password) surfaces as an inline
// message instead of the global interceptor clearing the session and
// hard-redirecting to /login (which would flash-and-wipe the error).

// POST /api/auth/login → { accessToken, refreshToken, tokenType, expiresIn(ms), user, requires2FA }
export const login = (data) =>
  post(url.POST_LOGIN, { email: data.email, password: data.password }, { skipAuthLogout: true });

// POST /api/auth/logout?token=<accessToken>&refreshToken=<refreshToken> — server-side
// revokes both tokens platform-wide.
export const logout = (token, refreshToken) =>
  post(`${url.POST_LOGOUT}?token=${encodeURIComponent(token)}`
    + (refreshToken ? `&refreshToken=${encodeURIComponent(refreshToken)}` : ""));

// POST /api/auth/forgot-password { email }
export const forgotPassword = (email) =>
  post(url.POST_PASSWORD_FORGET, { email }, { skipAuthLogout: true });

// POST /api/auth/reset-password { token, newPassword }
export const resetPassword = (data) =>
  post(url.POST_RESET_PASSWORD, data, { skipAuthLogout: true });

// POST /api/users/change-password { currentPassword, newPassword, confirmPassword }
export const changePassword = (data) =>
  post(url.POST_CHANGE_PASSWORD, data, { skipAuthLogout: true });
